import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateService} from '../../services/template.service';
import {Chart} from 'chart.js';
import * as _ from 'lodash';
import {ApiService} from '../../services/api.service';
import {HttpParams} from '@angular/common/http';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../../services/constant';
import {SendEmailModalComponent} from './sendEmailModal/send-email-modal.component';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-email-dashboard',
  templateUrl: './email-dashboard.component.html',
  styleUrls: ['./email-dashboard.component.scss'],
  providers: [TemplateService]
})
export class EmailDashboardComponent implements OnInit, OnDestroy {

  modal: NgbModalRef;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems = 0;
  transactions_sent: any;
  transactions_failed: any;
  transactions_wait_for_send: any;
  transactions_not_sent: any;
  sentChart: Chart;
  errorChart: Chart;
  emailTotal;
  data;
  status;
  allBuyerEmailsReport = null;
  allBuyerNamesReport = null;
  docType;
  myChart1;
  myChart2;
  loading;
  loading_main = false;
  datastatus = [];
  tableData = [];
  selectedCompany = null;
  company: any;
  branch: any;
  branchList: any = null;
  selectedBranch = null;
  allBranchList: any = null;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  defaultStartDate: string;
  defaultEndDate: string;
  clickedStartDate: string;
  clickedEndDate: string;
  calendarLocale = CALENDAR_LOCALE.TH;
  rdDocumentType: any;
  documentNumber: any;
  documentType: any;
  buyerName: string;
  email: any;
  sortBy = null;
  checkdate = null;
  sortMode = null;
  sentdata = null;
  searchingBuyerName: boolean = false;
  searchingEmail: boolean = false;
  params = null;
  subs: Subscription;

  constructor(private apiService: ApiService,
              private translate: TranslateService,
              private template: TemplateService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
    this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadInitData();
      this.searchButtonClicked();
    });
    this.loadInitData();
    this.searchButtonClicked();
  }

  generateChart() {
    this.sentChart = new Chart('sentChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Sent Chart',
          data: [this.transactions_sent, this.transactions_failed],
          backgroundColor: [
            '#69a769',
            '#5b5a5a',
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });

    this.errorChart = new Chart('errorChart', {
      type: 'doughnut',
      data: {
        datasets: [{
          label: 'Failed Chart',
          data: [this.transactions_failed, this.transactions_sent],
          backgroundColor: [
            '#cc0000',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
  }

  pageChanged() {
    this.sentdata = 1;
    this.loadData(this.currentPage);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.status = null;
    this.loadData();
  }

  loadInitData() {
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.loading_main = true;
    this.rdDocumentType = this.template.getDropdown();
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.company = _.uniqBy(this.company, 'label');
      },
      error => error(status)
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    this.apiService.getAllBuyerEmailsReport().subscribe(
      (result) => {
        this.allBuyerEmailsReport = result.all_buyer_emails_report;
      }
    );

    this.apiService.getAllBuyerNamesReport().subscribe(
      (result) => {
        this.allBuyerNamesReport = result.all_buyer_name_email_report;
      }
    );
  }

  filterStatus(data?) {
    this.currentPage = 1;
    this.status = data;
    this.loadData(this.currentPage, this.status);
  }

  loadData(page?, data?) {
    this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
    this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
    this.tableData = [];
    this.datastatus = [];
    const sniffTargetArr: string[] = [];
    let params = new HttpParams();
    if (this.status) {
      params = params.append('status', this.status);
      sniffTargetArr.push('EMAIL-DASHBOARD.STATUS');
    }
    if (this.selectedCompany) {
      params = params.append('corporate', this.selectedCompany);
      sniffTargetArr.push('FILTER.COMPANY');
    }
    if (this.selectedBranch) {
      params = params.append('corporate_branch', this.selectedBranch);
      sniffTargetArr.push('FILTER.BRANCH');
    }
    if (this.documentNumber) {
      params = params.append('document_number', this.documentNumber);
      sniffTargetArr.push('EMAIL-DASHBOARD.DOC-NUM');
    }
    if (this.buyerName) {
      params = params.append('buyer_name', this.buyerName);
      sniffTargetArr.push('TAX-B2P.FILTER.BUYER');
    }
    if (this.email) {
      params = params.append('email', this.email);
      sniffTargetArr.push('EMAIL-DASHBOARD.EMAIL');
    }
    if (this.sentdata) {
      params = params.append('page', this.currentPage.toString());
      params = params.append('page_size', this.itemsPerPage.toString());
    }
    params = params.append('sent_date_gte', moment(this.startDate).format('YYYY-MM-DD'));
    params = params.append('sent_date_lte', moment(this.endDate).format('YYYY-MM-DD'));

    this.apiService.getEmailDashboard(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.tableData.push({
          id: obj.id,
          broker_name: obj.broker_name,
          buyer_name: obj.buyer_name,
          email_data: obj.email_data.emails || [],
          cc_email_data: obj.email_data.cc_list || [],
          document_number: obj.document_number || [],
          customer_broker_batch_zip_id: obj.customer_broker_batch_zip_id,
          status: obj.status,
          sent_date: obj.sent_date
        });
      });
      if (result) {
        this.totalItems = result.count;
        this.emailTotal = result.transactions_sent + result.transactions_failed;
        this.transactions_sent = result.transactions_sent;
        this.transactions_failed = result.transactions_failed;
        this.transactions_wait_for_send = result.transactions_wait_for_send;
        this.transactions_not_sent = result.transactions_not_sent;
      }
      this.loading_main = false;
      if (!this.sentChart && !this.errorChart) {
        this.generateChart();
      } else {
        this.sentChart.destroy();
        this.errorChart.destroy();
        this.generateChart();
      }

      this.loading_main = false;
    });
    this.loading_main = false;

    if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
      sniffTargetArr.push('EMAIL-DASHBOARD.SENT-DATE');
    }

    if (page == null || data) {
      const sniffTarget = sniffTargetArr.join(', ');
      this.sniff('SEARCH', sniffTarget);
    }
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  clearData() {
    this.transactions_failed = null;
    this.transactions_wait_for_send = null;
    this.transactions_not_sent = null;
    this.transactions_sent = null;
    this.datastatus = null;
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.rdDocumentType = null;
    this.branchList = null;
    this.company = null;
    this.email = null;
    this.endDate = new Date();
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems = 0;
    this.checkdate = null;
    this.currentPage = 1;
    this.selectedBranch = null;
    this.params = null;
    this.selectedCompany = null;
    this.documentNumber = null;
    this.buyerName = null;
    this.loadInitData();
    this.searchButtonClicked();
  }

  filterBranchList() {
    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate == this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  openMailModal(index) {
    const modal = this.modalService.open(SendEmailModalComponent, {keyboard: false, centered: true});
    const modalContent = modal.componentInstance;

    modalContent.modalData = this.tableData[index];
  }

  name = '';

  public placeholder: string = 'Search Email';
  public keyword = 'name';
  public historyHeading: string = 'Recently selected';

  public emailList = ['a@a.com', 'b@b.com'];

  sniff(action, target) {
    const data = {
      action: action,
      address: 'EMAIL_DASHBOARD',
      target: target
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts